export function clampToIndex(index: number, maxIndex: number): number {
  if (index < 0) {
    return 0
  }

  if (index > maxIndex) {
    return maxIndex
  }

  return index
}
